import { render } from "./Code.vue.js?vue&type=template&id=25978229!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Code.vue?vue&type=template&id=25978229"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__